import { IPortalPageResponse } from "@ecp-redux/dto/page/portal.types";

export const getModifiedSectionUuid = (
  section: IPortalPageResponse["page"]["sections"][0],
  isMobile: boolean
) => section.uuid + (isMobile ? section.sectionOrder : 0);
